import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../../constants/z_index';
export const getStyle = () => {
  return {
    top: 0,
    position: 'absolute',
    height: '100vh',
    width: '100vw',
    zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT,
    backgroundColor: 'transparent',
    left: 0,
    border: 'none',
    display: 'none'
  };
};